import React from "react";
import Masonry from "react-masonry-css";
import Imagen from "./Imagen";

const breakpointColumnsObj = {
  default: 4,
  3000: 5,
  2000: 4,
  1200: 3,
  1000: 2,
  500: 1,
};

const ListadoImagenes = ({ imagenes }) => {
  return (
    // <div className="col-12 p-5 row">
    <Masonry className="col-12 p-5 row" breakpointCols={breakpointColumnsObj}>
      {imagenes?.map((imagen) => (
        <Imagen key={imagen.id} imagen={imagen} className="w-max" />
      ))}
    </Masonry>

    // </div>
  );
};

export default ListadoImagenes;
